<template>
  <v-dialog
    :value="visiblePopup"
    :max-width="980"
    @click:outside="onNoClickButton"
    @keydown.esc="onNoClickButton"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='port-wrapper'>
        <v-chip-group
          active-class='primary--text'
          column
          multiple
          :key="visiblePopup"
        >
          <v-chip
            v-for="port in sortPortsBySeverity"
            :key="port"
            @click='addChip(port)'
            class='port'
            :class="[mapPortColor(port)]"
          >
            {{ port }}
          </v-chip>
        </v-chip-group>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()" :disabled='saveDisabled'>
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>

import { mapGetters } from 'vuex';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectPortPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedPorts: [],
    };
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.selectedPorts);
      this.selectedPorts = [];
    },
    onNoClickButton() {
      this.$emit('clicked', false);
      this.selectedPorts = [];
    },
    addChip(port) {
      if (this.selectedPorts.includes(port)) {
        this.selectedPorts = this.selectedPorts.filter(item => item !== port);
      } else {
        this.selectedPorts.push(port);
      }
    },
    mapPortColor(port) {
      if (!this.portsToScoreMap[port]) {
        return '';
      }
      if (this.portsToScoreMap[port].severity === this.$t('informative')) {
        return 'informative';
      }
      if (this.portsToScoreMap[port].severity === this.$t('low')) {
        return 'low';
      }
      if (this.portsToScoreMap[port].severity === this.$t('medium')) {
        return 'medium';
      }
      if (this.portsToScoreMap[port].severity === this.$t('high') || this.portsToScoreMap[port].severity === this.$t('critical')) {
        return 'high';
      }
      return '';
    },
  },
  computed: {
    ...mapGetters([
      'portsToScoreMap',
      'configurationHosts',
      'portOptions',
    ]),
    saveDisabled() {
      return this.selectedPorts.length === 0;
    },
    portValues() {
      const sortedPorts = [...this.portOptions];
      return sortedPorts.sort((a, b) => a - b);
    },
    sortPortsBySeverity() {
      const sortedArray = this.portValues;
      const severityOrder = ['critical', 'high', 'medium', 'low', 'informative'];
      sortedArray.sort((a, b) => {
        const severityA = this.portsToScoreMap[a] ? this.portsToScoreMap[a].severity : '';
        const severityB = this.portsToScoreMap[b] ? this.portsToScoreMap[b].severity : '';
        const indexA = severityOrder.indexOf(severityA);
        const indexB = severityOrder.indexOf(severityB);
        if (indexA === indexB || (indexA === 0 && indexB === 1) || (indexB === 0 && indexA === 1)) {
          return Number(a) - Number(b);
        }
        if (severityA === '') {
          return 1;
        }
        if (severityB === '') {
          return -1;
        }
        return indexA - indexB;
      });
      return sortedArray;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/design-system';
  .popup-wrapper {
    max-width: rem(980);
    min-width: rem(980);
    padding: $space-8 $space-10;
    .port-wrapper {
      min-width: rem(980);
      margin-bottom: rem(-20);
      .port {
        margin-bottom: $space-1-5;
        background: rgba(43, 175, 105, 0.2);
        color: #2BAF69;
        &.informative {
          background: var(--severity-informative-bg);
          color: var(--severity-informative);
        }
        &.low {
          background: var(--severity-low-bg);
          color: var(--severity-low);
        }
        &.medium {
          background: var(--severity-medium-bg);
          color: var(--severity-medium);
        }
        &.high {
          background: var(--severity-critical-bg);
          color: var(--severity-critical);
        }
        &.critical {
          background: var(--severity-critical-bg);
          color: var(--severity-critical);
        }
      }
    }

    .title {
      color: var(--text-primary);
      font-size: $font-size-sm;
      font-weight: 600;
      letter-spacing: 1.12px;
      line-height: $space-4;
      text-transform: uppercase;
      padding-bottom: rem(23);
    }

    .buttons {
      text-align: right;
      padding-top: rem(30);

      .no-button {
        box-sizing: border-box;
        height: $btn-height-md;
        width: rem(86);
        border: $border-width-thin solid var(--brand-primary);
        color: var(--brand-primary);
        border-radius: $radius-sm;
        background-color: var(--bg-primary);
        box-shadow: $shadow-sm;
      }

      .yes-button {
        height: $btn-height-md;
        width: rem(51);
        border-radius: $radius-sm;
        box-shadow: $shadow-sm;
        font-size: $font-size-xs;
        font-weight: 500;
        letter-spacing: 1.07px;
        line-height: $space-4;
        text-align: center;
        margin-left: $space-2;
      }
    }
  }

</style>
